import { Injectable } from '@angular/core';
import { getDocumentationWindowPhase, scheduleChange } from '@app/utils';
import { DocumentationWindowPhase } from '@app/enums';
import { DOCUMENTATION_WINDOW } from '@utils/constants/generals';
import { ValueClockModel } from '@models/index';
import { FlightSummary } from '@models/micro';
import moment from 'moment';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

/**
 * Estado emitido por el contador de la ventana de documentación.
 * `h`/`m` representan el tiempo hasta la apertura; `phase` indica si se puede documentar.
 */
export interface DocumentationWindowCountdownInt {
  h: number;
  m: number;
  valid: boolean;
  phase: DocumentationWindowPhase;
}

@Injectable({
  providedIn: 'root',
})
export class ClockService {
  clock: Observable<Date>;
  infofecha$ = new BehaviorSubject<ValueClockModel>(new ValueClockModel());
  vr: ValueClockModel = new ValueClockModel();
  hours = 0;
  minute = '';
  weekday = '';
  months = '';

  constructor() {
    this.clock = timer(0, 1500).pipe(
      map(() => new Date()),
      shareReplay(1)
    );
  }
  getInfoReloj(): Observable<ValueClockModel> {
    this.clock.subscribe((t) => {
      this.hours = t.getHours() % 12;
      this.hours = this.hours ? this.hours : 12;
      this.vr = {
        hora: t.getHours(),
        minutos: t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes().toString(),
        ampm: t.getHours() > 11 ? 'PM' : 'AM',
        diaymes: t
          .toLocaleString('es-MX', { day: '2-digit', month: 'long' })
          .replace('.', '')
          .replace('-', ' '),
        diadesemana: t.toLocaleString('es-MX', { weekday: 'long' }).replace('.', ''),
        segundo: t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds().toString(),
      };
      this.infofecha$.next(this.vr);
    });
    return this.infofecha$.asObservable();
  }

  startCountDown(
    flightSumary: FlightSummary,
    location: string
  ): Observable<DocumentationWindowCountdownInt> {
    const { departureDateTime } = flightSumary;
    const period = 15 * 1000;

    return timer(0, period).pipe(
      map(() => {
        const departureDate = moment(departureDateTime);
        const dateInit = departureDate
          .clone()
          .subtract(DOCUMENTATION_WINDOW.OPENING_HOURS, 'hours');
        const dateInitValue = dateInit.toDate();
        const res = moment(dateInitValue).diff(new Date(), 'minutes');
        let h = Math.floor(res / 60);
        h = h < 0 ? 0 : h;
        let m = res % 60;
        m = m < 0 ? 0 : m;
        const valid = scheduleChange(flightSumary, location);
        const phase = getDocumentationWindowPhase(flightSumary, location);
        return {
          h,
          m,
          valid,
          phase,
        };
      }, shareReplay(1))
    );
  }
}
